import { render, staticRenderFns } from "./menuAppsR.vue?vue&type=template&id=20c95f18&scoped=true"
import script from "./menuAppsR.vue?vue&type=script&lang=js"
export * from "./menuAppsR.vue?vue&type=script&lang=js"
import style0 from "./menuAppsR.vue?vue&type=style&index=0&id=20c95f18&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c95f18",
  null
  
)

export default component.exports